export default __webpack_public_path__ + "6c362217519294f087eb4d24be53123d.png";